import { AxiosRequestConfig, AxiosResponse } from "axios";
import AuthTokenHolder, { TOKEN_KEY } from "@/services/http/AuthTokenHolder";
import responseHandler from "./responseHandler";
import responseRejectedHandler from "./responseRejectedHandler";
import qs from "qs";

/**
 * 请求拦截器（请求还未发送出去）
 */
const requestInterceptor = (config: AxiosRequestConfig) => {
    const token = AuthTokenHolder.getToken();
    // 判断是否存在token，如果存在的话，则每个需要请求头有权限的请求header都加上token

    // 除了扫码登录不加请求头
    if (token) {
        config.headers[TOKEN_KEY] = token;
    }

    config["_requestId"] = new Date().getTime();

    /** 解决Get请求中axios对功能性字符不编码 */
    config.paramsSerializer = function (params) {
        return qs.stringify(params);
    };

    return config;
};

/**
 * 请求阶段发生错误的拦截器（请求还未发送出去）
 */
const requestRejectedInterceptor = (error: any) => {
    return Promise.reject(error);
};

/**
 * 响应拦截器 （已经拿到数据）
 */
const responseInterceptor = (response: AxiosResponse) => {
    return responseHandler(response);
};

/**
 * 还未响应时发生错误时的拦截器 （还未拿到数据）
 */
const responseRejectedInterceptor = (error: any) => {
    return responseRejectedHandler(error);
};

export { requestInterceptor, requestRejectedInterceptor, responseInterceptor, responseRejectedInterceptor };
